var $1be8b0ee8841f1e7$exports = {};
$1be8b0ee8841f1e7$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Pr\xF3bnik kolor\xF3w",
  "colorSwatch": "pr\xF3bka koloru",
  "transparent": "przezroczysty",
  "twoDimensionalSlider": "Suwak 2D"
};
export { $1be8b0ee8841f1e7$exports as default };